module.exports = __webpack_public_path__ + "static/media/Header-beneficios.acda5f69.jpg";